import api from 'api';

export const changeInvoiceComment = api(
  'POST /api/financial-results/invoices/:id/comment'
);

export const undoInvoice = api(
  'POST /api/financial-results/invoices/:id/cancel'
);

export const payInvoice = api('POST /api/financial-results/invoices/:id/pay');

export const loadInvoicesSpend = api(
  'POST /api/financial-results/invoices/spend'
);
export const replaceInvoiceAttachment = api(
  'POST /api/financial-results/invoices/:id/replace-attachment'
);
